import botImg from '../../assets/image/front_pg_avatar.svg';

const clientType = process.env.REACT_APP_CLIENT;
const CopilotIntro = () => {
  // const name = localStorage.getItem('name');
  return (
    <>
      <div className="h-full w-full flex flex-col items-center justify-center">
        <img src={botImg} alt="Welcome" className="w-30 h-auto" />
        {clientType === 'salesbot2290ai' ? (
          <h1 className="text-[14px] text-[#2B2F38] font-normal text-center p-6">
            File your 2290 in under 2 minutes, want to get started?
          </h1>
        ) : (
          <h1 className="text-[14px] text-[#2B2F38] font-normal text-center p-6">
            Hi there! I’m Zenwork, your AI assistant at Tax1099, here to guide you
            and answer any questions about the platform. What can I walk you
            through today?
          </h1>
        )}
      </div>
    </>
  );
};

export default CopilotIntro;